module.exports = __webpack_public_path__ + "static/media/L.0d68d9e3.gif";